'use client';

import { c as _c } from "react/compiler-runtime";
import { Accordion } from '@common/components/molecule/Accordion';
import type { MedianIncomeYear } from '../constants';
import { MEDIAN_INCOME_BY_YEAR } from '../constants';
interface FaqListProps {
  year: MedianIncomeYear;
}

/**
 * ⑨ FAQ — 자주 묻는 질문.
 */
export const FaqList = t0 => {
  const $ = _c(14);
  const {
    year
  } = t0;
  const {
    faqList,
    source
  } = MEDIAN_INCOME_BY_YEAR[year];
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h2 className="font-700 text-Gray-900 typo-h5 mobile-tablet:typo-h6">자주 묻는 질문</h2>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== faqList.length) {
    t2 = <p className="text-Gray-700 typo-body4">중위소득·기초생활보장에 대한 핵심 질문 {faqList.length}가지를 정리했습니다.</p>;
    $[1] = faqList.length;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== faqList) {
    t3 = faqList.map(_temp);
    $[3] = faqList;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <Accordion multiple={true}>{t3}</Accordion>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <strong className="font-700 text-Gray-700">출처:</strong>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== source) {
    t6 = <p className="text-Gray-600 typo-caption1">{t5} {source} / 통계청 가계금융복지조사</p>;
    $[8] = source;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t2 || $[11] !== t4 || $[12] !== t6) {
    t7 = <section className="flex flex-col gap-12 mobile-tablet:px-16">{t1}{t2}{t4}{t6}</section>;
    $[10] = t2;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};
function _temp(faq, index) {
  return <Accordion.Item key={faq.q} value={faq.q}><Accordion.Trigger title={`Q${index + 1}. ${faq.q}`} /><Accordion.Content><div dangerouslySetInnerHTML={{
        __html: faq.a
      }} /></Accordion.Content></Accordion.Item>;
}